<template>
  <div>
    <div class="card">
      <div class="card-body">
        <h5 class="mb-4">
          <strong>Tambah Pasien Baru</strong>
        </h5>
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Kode Pasien"
          >
            <a-input
              :disabled="submitting"
              placeholder="Kode Pasien"
              v-decorator="[
                'code',
                {
                  rules: [
                    { required: true, message: 'Kode Pasien harus diisi!' },
                  ],
                },
              ]"
            />
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Kota"
          >
            <a-select
              :disabled="submitting"
              v-decorator="[
                'city',
                { rules: [{ required: true, message: 'Kota harus diisi!' }] },
              ]"
              placeholder="Kota"
            >
              <a-select-option
                v-for="city in cityList"
                :key="city.id"
                :value="city.name"
              >
                {{ city.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Nama"
          >
            <a-input
              :disabled="submitting"
              placeholder="Nama"
              v-decorator="['fullname']"
            />
          </a-form-item>
          <!-- {rules: [{ required: true, message: 'Nama harus diisi!' }]} -->
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Tanggal Lahir"
          >
            <a-date-picker
              :disabled="submitting"
              v-decorator="['dateOfBirth']"
            />
          </a-form-item>
          <!-- {rules: [{ required: true, message: 'Tanggal Lahir harus diisi!' }]} -->
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Nomor KTP"
          >
            <a-input
              :disabled="submitting"
              placeholder="Nomor KTP"
              v-decorator="['idNumber']"
            />
          </a-form-item>
          <!-- {rules: [{ required: true, len: 16, message: 'Nomor KTP harus 16 digit!' }]} -->
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Jenis Kelamin"
          >
            <a-select
              :disabled="submitting"
              v-decorator="['gender']"
              placeholder="Jenis Kelamin"
            >
              <!-- { rules: [{ required: true, message: 'Jenis Kelamin harus diisi!' }] }, -->
              <a-select-option
                v-for="gender in genderList"
                :key="gender.value"
                :value="gender.value"
              >
                {{ gender.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="E-mail"
          >
            <a-input
              :disabled="submitting"
              placeholder="E-mail"
              v-decorator="['email']"
            />
          </a-form-item>
          <!-- {rules: [{ required: true, message: 'E-mail harus diisi!' }]} -->
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Kata Sandi"
          >
            <a-input
              :disabled="submitting"
              placeholder="Kata Sandi"
              v-decorator="['password']"
            />
          </a-form-item>
          <!-- { rules: [{ required: true, min: 8, message: 'Kata Sandi harus 8 karakter atau lebih!' }]} -->
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Konfirmasi Kata Sandi"
          >
            <a-input
              :disabled="submitting"
              placeholder="Konfirmasi Kata Sandi"
              v-decorator="['confirmPassword']"
            />
          </a-form-item>
          <!-- { rules: [{ required: true, message: 'Konfirmasi Kata Sandi harus diisi!' }]} -->
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Nama Perwakilan"
          >
            <a-input
              :disabled="submitting"
              placeholder="Nama Perwakilan"
              v-decorator="['representativeName']"
            />
            <!-- { rules: [{ required: true, message: 'Nama Perwakilan harus diisi!' }]} -->
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Nomor Telepon Perwakilan"
          >
            <a-input
              :disabled="submitting"
              placeholder="Nomor Telepon Perwakilan"
              v-decorator="['representativePhone']"
            />
          </a-form-item>
          <!-- { rules: [{ required: true, message: 'Nomor Telepon Perwakilan harus diisi!' }]} -->
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Hubungan Perwakilan"
          >
            <a-input
              :disabled="submitting"
              placeholder="Hubungan Perwakilan"
              v-decorator="['representativeRelationship']"
            />
          </a-form-item>
          <!-- {rules: [{ required: true, message: 'Hubungan Perwakilan harus diisi!' }]} -->
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Foto KTP"
          >
            <a-upload
              :multiple="false"
              v-decorator="[
                'image',
                {
                  valuePropName: 'image',
                },
              ]"
              name="upload"
              :action="action"
              list-type="picture"
              :file-list="fileList"
              @change="handleChange"
            >
              <!-- rules: [{required: true, message: 'Foto KTP harus diisi!' }] -->
              <a-button> <a-icon type="upload" /> Click to upload </a-button>
            </a-upload>
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="Foto Selfie"
          >
            <a-upload
              :multiple="false"
              v-decorator="[
                'image2',
                {
                  valuePropName: 'image2',
                },
              ]"
              name="upload"
              :action="action2"
              list-type="picture"
              :file-list="fileList2"
              @change="handleChange2"
            >
              <!-- rules: [{required: true, message: 'Foto Selfie harus diisi!' }] -->
              <a-button> <a-icon type="upload" /> Click to upload </a-button>
            </a-upload>
          </a-form-item>
          <button
            type="submit"
            class="btn btn-success px-5"
            :disabled="submitting"
          >
            Simpan Data
          </button>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import router from '@/router'
import { getAll as getAllCity } from '@/services/axios/api/city'
import { create } from '@/services/axios/api/pasien'
import { BASE_URL } from '@/config'
import { notification } from 'ant-design-vue'

const labelCol = {
  xs: { span: 24 },
  sm: { span: 5 },
}
const wrapperCol = {
  xs: { span: 24 },
  sm: { span: 12 },
}
export default {
  data: function () {
    return {
      form: this.$form.createForm(this),
      labelCol,
      wrapperCol,
      cityList: [],
      genderList: [
        { name: 'Pria', value: 'male' },
        { name: 'Wanita', value: 'female' },
      ],
      submitting: false,
      action: `${BASE_URL}/upload/id`,
      // action: `${BASE_URL}/upload/id`,
      action2: `${BASE_URL}/upload/selfie`,
      // action2: `${BASE_URL}/upload/selfie`,
      fileList: [],
      fileList2: [],
      checkPoint: 0,
    }
  },
  created() {
    this.getCityList()
    this.$store.state.patientData = []
  },
  methods: {
    async getCityList() {
      const res = await getAllCity()
      this.cityList = res
    },
    handleChange(info) {
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.url
        }
        return file
      })

      this.fileList = fileList
    },
    handleChange2(info) {
      let fileList2 = [...info.fileList]
      fileList2 = fileList2.slice(-1)
      fileList2 = fileList2.map((file) => {
        if (file.response) {
          file.url = file.response.url
        }
        return file
      })

      this.fileList2 = fileList2
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.submitting = true
          try {
            values.idPicture = values.image
              ? values.image.file.response.data
              : ''
            values.selfiePicture = values.image2
              ? values.image2.file.response.data
              : ''
            values.image = null
            values.image2 = null
            console.log('Received values of form: ', values)
            const res = await create(values)
            console.log(res)
            if (res && res.data) {
              notification.success({
                message: 'Sukses',
                description: `Data berhasil ditambahkan, Kode pasien ${res.data.code}`,
                duration: 15,
              })
              router.push('/pasien')
            }
            this.submitting = false
          } catch (e) {
            this.submitting = false
          }
        } else {
          console.log(err)
          console.log(values)
        }
      })
    },
  },
}
</script>
